import numeral from 'numeral'

export const floatToDollars = (amount) => {
  return numeral(amount).format('0.00')
}

export const centsToFloat = (amountInCents) => {
  return numeral(amountInCents / 100).format('0.00')
}

export const stringFloatToCents = (amount) => {
  return parseFloat(amount) * 100
}

export const dollarsToFloat = (amount = '$0.00') => {
  return parseFloat(amount?.replace(/[^\d.-]/g, ''))
}

export const dollarsToCents = (amount) => {
  return parseInt(dollarsToFloat(amount) * 100)
}
